export const AuthFormTranslationsEn = {
  placeholderLogin: 'Email / Phone Number',
  description: 'Authorize using your login (enter phone number or email)',
  login: 'Login',
  password: 'Password',
  forgotPassword: 'I forgot my password',
  submitButton: 'Log in',

  //errors
  'Required field': 'Required field',
  validLogin: 'Enter a valid Login (email or valid phone number)',

  // errors back-end
  'login or password is wrong': 'Login or password is wrong',
};
